import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faPhone } from "@fortawesome/free-solid-svg-icons";

const CTASection = () => {
  return (
    <div className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-primary-500 to-primary-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-heading-xl md:text-display-sm text-white font-bold mb-6">
          Ready to Start Your Mental Health Journey?
        </h2>
        <p className="text-body-lg md:text-heading-sm text-white/90 mb-10 leading-relaxed max-w-2xl mx-auto">
          Take the first step towards better mental health today. Our compassionate team is here to support you every step of the way.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <button className="group px-8 py-4 bg-white text-primary-600 font-semibold rounded-lg hover:bg-neutral-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-3 justify-center">
              Schedule Consultation
              <FontAwesomeIcon
                icon={faArrowRight}
                className="transition-transform group-hover:translate-x-1"
              />
            </button>
          </Link>
          <a href="tel:2406103766">
            <button className="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-white/10 transition-all duration-300 flex items-center gap-3 justify-center">
              <FontAwesomeIcon icon={faPhone} />
              Call (240) 610-3766
            </button>
          </a>
        </div>

        <div className="mt-12 pt-8 border-t border-white/20">
          <p className="text-body-md text-white/80">
            Serving Maryland, Washington D.C., and Virginia
          </p>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
